export default "__VITE_ASSET__Kfw6Fmig__"